<template>
  <div class="wrapper">
    <img class="cover" src="@/assets/logo.png" alt="" />
    <span class="title">MuleEx</span>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.wrapper {
  display: flex;
  gap: 5px;
  margin-top: 20px;
}

.cover {
  height: 38px;
  display: block;
}

.title {
  font-weight: 600;
  font-size: 25px;
}
</style>
